;(function () {
	const initTabs = (section) => {
		const tabs = section.querySelectorAll('.collection-pills__pill[data-tab]')
		const panels = section.querySelectorAll('.collection-card__panel[data-panel]')
		if (!tabs.length || !panels.length) return

		const activate = (tab) => {
			tabs.forEach((t) => {
				t.classList.remove('collection-pills__pill--active')
				t.setAttribute('aria-selected', 'false')
			})
			panels.forEach((p) => p.classList.remove('is-active'))

			tab.classList.add('collection-pills__pill--active')
			tab.setAttribute('aria-selected', 'true')

			const panel = section.querySelector(`.collection-card__panel[data-panel="${tab.dataset.tab}"]`)
			if (panel) panel.classList.add('is-active')
		}

		tabs.forEach((tab) => {
			tab.addEventListener('click', () => activate(tab))
			tab.addEventListener('keydown', (e) => {
				const list = [...tabs]
				const idx = list.indexOf(tab)
				if (e.key === 'ArrowRight') {
					e.preventDefault()
					const next = list[(idx + 1) % list.length]
					activate(next)
					next.focus()
				} else if (e.key === 'ArrowLeft') {
					e.preventDefault()
					const prev = list[(idx - 1 + list.length) % list.length]
					activate(prev)
					prev.focus()
				}
			})
		})
	}

	const initSection = (section) => {
		if (!section) return
		initTabs(section)
	}

	initSection(document.currentScript.parentElement)

	document.addEventListener('shopify:section:load', (event) => {
		initSection(event.target)
	})
})()
